/* Tidy Towel ad attribution (Oct 25 2026, tracking only: never touches items, prices or discount codes).
   Captures utm_source / utm_campaign / utm_content / tt_offer, the first landing path and an external referrer on ANY page,
   keeps first touch (set once) + last touch (latest visit with UTMs/tt_offer) in localStorage + cookie tt_attr (30 days),
   and writes them as cart attributes on load (cart with items) and after every /cart/add|change|update|clear:
   _utm_source _utm_campaign _ad _tt_offer _landing_path _referrer (+ _lt_utm_source _lt_utm_campaign _lt_ad _lt_tt_offer when they differ).
   _tt_offer: written only when the cart has none or has 'b2g1' (never overwrites 'sets3'); assets/tt-deal.js reads
   window.ttAttr.offer() so the B2G1 page tags the ad's tt_offer instead of b2g1. _landing stays owned by tt-deal.js
   (only filled with the first landing path if the cart has no _landing). Undo: landing/offer-attr-oct25/undo.py */
(function () {
  if (window.ttAttr) return;
  var KEY = 'tt_attr', DAYS = 30;
  function clean(v, max) {
    if (v == null) return '';
    v = String(v).replace(/[\u0000-\u001f\u007f<>"'`\\;]/g, '').replace(/javascript:|data:|vbscript:/gi, '').replace(/\s+/g, ' ').trim();
    return v.slice(0, max || 100);
  }
  function cleanOffer(v) { return String(v || '').replace(/[^A-Za-z0-9_-]/g, '').slice(0, 40); }
  function load() {
    var s = null;
    try { s = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (!s) { try { var m = document.cookie.match(/(?:^|; )tt_attr=([^;]*)/); if (m) s = JSON.parse(decodeURIComponent(m[1])); } catch (e) {} }
    return (s && typeof s === 'object') ? s : null;
  }
  function save(s) {
    var j = JSON.stringify(s);
    try { localStorage.setItem(KEY, j); } catch (e) {}
    try { document.cookie = KEY + '=' + encodeURIComponent(j) + '; path=/; max-age=' + (DAYS * 86400) + '; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : ''); } catch (e) {}
  }
  var F = ['utm_source', 'utm_campaign', 'utm_content', 'tt_offer'];
  var q = {}, has = false;
  try {
    var p = new URLSearchParams(location.search); /* decodes %20 and + */
    F.forEach(function (k) { var v = p.get(k); if (v != null && v !== '') { v = k === 'tt_offer' ? cleanOffer(v) : clean(v, 100); if (v) { q[k] = v; has = true; } } });
  } catch (e) {}
  var ref = '';
  try {
    if (document.referrer) {
      var r = new URL(document.referrer), h = r.hostname.toLowerCase();
      if (!/(^|\.)shoptidytowel\.com$|\.myshopify\.com$|(^|\.)shopify\.com$/.test(h) && h !== location.hostname) ref = clean(r.origin + r.pathname, 100);
    }
  } catch (e) {}
  var s = load() || {}, now = new Date().toISOString(), dirty = false;
  if (!s.ft) { s.ft = { path: clean(location.pathname, 100), ref: ref, t: now }; F.forEach(function (k) { if (q[k]) s.ft[k] = q[k]; }); dirty = true; }
  else if (has && !F.some(function (k) { return s.ft[k]; })) { F.forEach(function (k) { if (q[k]) s.ft[k] = q[k]; }); if (!s.ft.ref && ref) s.ft.ref = ref; dirty = true; }
  if (has) {
    var lt = {}; F.forEach(function (k) { if (q[k]) lt[k] = q[k]; });
    var prev = s.lt || {};
    if (F.some(function (k) { return (lt[k] || '') !== (prev[k] || ''); })) { lt.t = now; s.lt = lt; dirty = true; }
  }
  if (dirty) save(s);

  function desired(cart) {
    var a = {}, ft = s.ft || {}, lt = s.lt || {}, ca = (cart && cart.attributes) || {};
    var map = { utm_source: '_utm_source', utm_campaign: '_utm_campaign', utm_content: '_ad' };
    Object.keys(map).forEach(function (k) { if (ft[k]) a[map[k]] = ft[k]; });
    if (ft.tt_offer && (!ca._tt_offer || ca._tt_offer === 'b2g1')) a._tt_offer = ft.tt_offer;
    if (ft.path) { a._landing_path = ft.path; if (!ca._landing) a._landing = ft.path.replace(/^\/pages\//, '').replace(/^\//, '') || 'home'; }
    if (ft.ref) a._referrer = ft.ref;
    var lmap = { utm_source: '_lt_utm_source', utm_campaign: '_lt_utm_campaign', utm_content: '_lt_ad', tt_offer: '_lt_tt_offer' };
    Object.keys(lmap).forEach(function (k) { if (lt[k] && lt[k] !== ft[k]) a[lmap[k]] = lt[k]; });
    var diff = {}, n = 0;
    Object.keys(a).forEach(function (k) { if (ca[k] !== a[k]) { diff[k] = a[k]; n++; } });
    return n ? diff : null;
  }
  var of = window.fetch ? window.fetch.bind(window) : null, busy = false, timer = null, again = false;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function sync(force) {
    if (!of) return Promise.resolve();
    if (busy) { again = true; return Promise.resolve(); }
    busy = true;
    return of(root + 'cart.js', { credentials: 'same-origin', headers: { 'X-TT-Attr': '1' } }).then(function (r) { return r.json(); }).then(function (c) {
      if (!c || (!c.item_count && !force)) return;
      var d = desired(c); if (!d) return;
      return of(root + 'cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'X-TT-Attr': '1' }, body: JSON.stringify({ attributes: d }) });
    }).catch(function () {}).then(function () { busy = false; if (again) { again = false; later(); } });
  }
  function later() { clearTimeout(timer); timer = setTimeout(sync, 700); }
  if (of) {
    window.fetch = function (input, init) {
      var p = of.apply(window, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        var mine = init && init.headers && (init.headers['X-TT-Attr'] || (init.headers.get && init.headers.get('X-TT-Attr')));
        if (!mine && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) p.then(function (r) { if (r && r.ok) later(); }, function () {});
      } catch (e) {}
      return p;
    };
  }
  window.ttAttr = {
    data: function () { return JSON.parse(JSON.stringify(s)); },
    offer: function () { return (s.ft && s.ft.tt_offer) || ''; },
    sync: sync
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { later(); }); else later();
})();
